let mockDispatch: any;

if (typeof jest !== 'undefined') {
  mockDispatch = jest.fn();
  mockDispatch.mockImplementation((action: any, state: any) => {
    if (typeof action === 'function') {
      return action(mockDispatch, state);
    }
  });
} else {
  // Provide a simple fallback for non-test environments
  mockDispatch = (action: any, state: any) => {
    if (typeof action === 'function') {
      return action(mockDispatch, state);
    }
  };
}

export { mockDispatch };
